import BaseModel from '@/orm/models/BaseModel';

export default class IntegrationVacancy extends BaseModel {
  static entity = 'integrationVacancies'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      provider: this.attr(null),
      externalId: this.attr(null),
      cities: this.attr(null),
      salary: this.attr(null),
      connected: this.boolean(false),
    };
  }

  static apiConfig = {
    actions: {
      fetchAllByProvider(companyId, integrationId, provider) {
        return this.get(`companies/${companyId}/integrations/${integrationId}/vacancies`, {
          dataTransformer: (r) => {
            return r.data.data.map((i) => {
              return { ...i, provider };
            });
          },
        });
      },
      import(companyId, integrationId, payload) {
        return this.post(`companies/${companyId}/integrations/${integrationId}/import-vacancies`, payload, {
          save: false,
        });
      },
      updateLinks(vacancyId, payload) {
        return this.post(`vacancies/${vacancyId}/integrations`, payload, { save: false });
      },
    },
  }
}
